import { css } from 'lit';
import componentStyles from '../../styles/component.styles';
export default css `
    ${componentStyles}
    :host {
        box-sizing: content-box;
    }

    .table {
        font-family: var(--sgdf-input-font-family);
        font-weight: var(--sgdf-font-weight-semibold);
        border-collapse: collapse;
        width: 100%;
        display: inline-block;
        border-spacing: 0;
    }

    table.sgdf-tbl thead th {
        background-color: var(--sgdf-color-default);
        color: #fff;
        font-weight: bold;
    }

    table.sgdf-tbl tbody td {
        height: 2.5rem;
        padding: 0;
        margin: 0;
        border: 0px;
    }

    .table .td a {
        display: flex;
        align-items: center;
        margin: 0;
        height: 100%;
        width: 100%;
        padding: 5px 10px;
        box-sizing: border-box;
        color: #000;
        text-decoration: none;
    }

    .table .tr {
        background: var(--sgdf-blue);
        border: 0px;
        cursor: pointer;
    }

    .table .th,
    .table .td {
        margin: 0;
        padding: 0.5rem;
        /* border-bottom: 1px solid black;
      border-right: 1px solid black; */

        display: inline-block;
        box-sizing: border-box;
        overflow: hidden;
    }

    .table .th {
        background-color: var(--sgdf-color-default);
        color: #fff;
        font-weight: bold;
        padding: 5px 10px;
        flex-grow: 1;
        flex-shrink: 1;
        flex-basis: 0;
    }

    .table .td {
        flex-grow: 1;
        flex-shrink: 1;
        flex-basis: 0;
    }

    .table .row,
    .table .tr {
        display: flex;
        /* width: 860px; */
        width: '100%';
    }

    .table .tbody {
        overflow: auto;
        will-change: transform;
        direction: ltr;
    }

    .table .tbody .tr {
        border: 0px;
    }

    .cell-text {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }
    /* .table .tbody div:nth-child(even) {
      background: rgba(0, 58, 93, 0.3);
    } */

    .row-container {
        width: 100%;
    }

    .no-data {
        display: flex;
        justify-content: center;
        background-color: var(--sgdf-color-gray-100);
        color: var(--sgdf-color-gray-600);
    }

    .loading {
        position: relative;
    }

    .loading .bar {
        background-color: #e7e7e7;
        height: 14px;
        border-radius: 7px;
        width: 80%;
    }

    @keyframes loading {
        40% {
            background-position: 100% 0;
        }
        100% {
            background-position: 100% 0;
        }
    }

    .loading:after {
        position: absolute;
        transform: translateY(-50%);
        top: 50%;
        left: 0;
        content: '';
        display: block;
        width: 100%;
        height: 24px;
        background-image: linear-gradient(
            100deg,
            rgba(255, 255, 255, 0),
            rgba(255, 255, 255, 0.5) 60%,
            rgba(255, 255, 255, 0) 80%
        );
        background-size: 200px 24px;
        background-position: -100px 0;
        background-repeat: no-repeat;
        animation: loading 1s infinite;
    }
`;
//# sourceMappingURL=Table.styles.js.map